export const paramsDefault= ()=>{
    return{
        provider:null,
        observation:null,
        legalrepresentative:''
    }
}



export  default {


    show_pdf:false,
    providers:[],
    params:paramsDefault(),
    mails: [],
    file:null,
    paramsEmail:{
        to:[],
        subject:null,
        body:null,
        filename:null

    },
    pathPdf:null,
    preloader:false,
    authenticatedRole:''
}



// WEBPACK FOOTER //
// ./src/modules/provider_account_statement/state.js